import React from 'react';
import SelectTemplate from "pages/createMission/body/selectTemplate";
import Motif from "pages/createMission/body/motif";
import Period from "pages/createMission/body/period";
import Confirmation
    from "pages/createMission/body/confirmation";
import End from "pages/createMission/body/end";
import UseContext from "hooks/useContext";
import Invitation from "./body/invitation";

// Mission creation flow now requires a job post template. Steps reflect only
// the mission-specific information (motif, period, invitations) plus the
// confirmation/end states. Activity/prerequis/location/salary/contact/other
// are template-owned and are no longer part of the wizard.
const FormsCreate = () => {
    const {page} = UseContext()
    const display = {
        0: <SelectTemplate key={'selectTemplate'}/>,
        3: <Motif key={'motif'}/>,
        5: <Period key={'period'}/>,
        7: <Invitation key={'invitation'}/>,
        10: <Confirmation key={'confirmation'}/>,
        11: <End key={'end'}/>
    }

    return (
        <>
            {display[page]}
        </>
    );
};

export default FormsCreate;